import React, { useEffect, useState } from 'react';
import './Service.css';
import { motion } from 'framer-motion';
import { useNavigate } from "react-router-dom";
const ServiceTwo = () => {
    const slideInRight = {
        hidden: { opacity: 0, x: 150 },
        visible: {
            opacity: 1,
            x: 0,
            transition: {
                type: 'spring',
                bounce: 0.3,
                duration: 1,
            },
        },
    };
    const slideInLeft = {
        hidden: { opacity: 0, x: -150 },
        visible: {
            opacity: 1,
            x: 0,
            transition: {
                type: 'spring',
                bounce: 0.3,
                duration: 1,
            },
        },
    };
    const navigate = useNavigate();
    const handleScroll = (event, id) => {
        event.preventDefault();
        const currentPath = window.location.pathname;
        if (currentPath !== '/') {
            navigate('/', { state: { scrollTo: id } });
        } else {
            const section = document.getElementById(id);
            if (section) {
                const yOffset = -210;
                const y = section.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({ top: y, behavior: "smooth" });
            }
        }
    };
    return (
        <div className="service-two-container">
            <div className="service-row">
                <div className="service-image">
                    <img src='/assets/serviceTwo/service-bg-01.jpg' alt="Wheel Cleaning" />
                </div>
                <motion.div
                    className="service-content"
                    //  initial={{ x: '100vw' }}
                    //  animate={{ x: 0 }}
                    //  transition={{
                    //      type: 'spring',
                    //      stiffness: 70,
                    //      damping: 12,
                    //  }}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.5 }}
                    variants={slideInRight}
                >
                    <div className="service-content-details">
                        <h3 className='chakra-petch-bold'>SERVICE</h3>
                        <h2 className='chakra-petch-bold'>CAR EXTERIOR CLEANING:<br /> BASIC DETAILING</h2>
                        <ul className='font-mulish'>
                            <li>Same Day Service</li>
                            <li>Convenient Location</li>
                            <li>Online Appointment</li>
                            <li>Complimentary Shuttle</li>
                        </ul>
                        <button className="get-service-btn chakra-petch-semibold" onClick={(event) => handleScroll(event, 'contact')}>GET SERVICE</button>
                    </div>
                </motion.div>
            </div>
            <div className="service-row second-row">
                <motion.div
                    className="service-content"
                    //  initial={{ x: '-100vw' }}
                    //  animate={{ x: 0 }}
                    //  transition={{
                    //      type: 'spring',
                    //      stiffness: 70,
                    //      damping: 12,
                    //      duration: 1.5
                    //  }}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.5 }}
                    variants={slideInLeft}
                >
                    <div className="service-content-details">
                        <h3 className='chakra-petch-bold'>SERVICE</h3>
                        <h2 className='chakra-petch-bold'>RUBBING, WAXING, AND POLISHING</h2>
                        <p className='font-mulish'>
                            Our technicians have undergone the most extensive and stringent car detail
                            training program. And the only car that matters is yours because we will
                            detail it to your complete satisfaction.
                        </p>
                        <button className="get-service-btn chakra-petch-semibold" onClick={(event) => handleScroll(event, 'contact')}>GET SERVICE</button>
                    </div>
                </motion.div>
                <div className="service-image">
                    <img src='/assets/serviceTwo/service-bg-02.jpg' alt="Polishing Car" />
                </div>
            </div>
        </div>
    );
};

export default ServiceTwo;
